import { useTranslation } from 'react-i18next';

export default function WinterGardenSection() {
  const { t } = useTranslation();

  return (
    <section
      id="kis-bahcesi"
      className="relative flex min-h-[480px] w-full items-center justify-center overflow-hidden md:min-h-[600px]"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/3fc02ed0-655a-44a2-bdfe-be6f4b196b45_compressed_4.webp')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6">
        <p className="reveal mb-5 text-xs uppercase tracking-[0.4em] text-primary-400 md:text-sm">
          {t('s7.subtitle')}
        </p>
        <h2 className="reveal reveal-delay-1 font-heading text-3xl leading-tight text-background-50 md:text-4xl lg:text-5xl">
          {t('s7.title')}
        </h2>
        <a
          href="#iletisim"
          className="reveal reveal-delay-2 mt-9 inline-block whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
        >
          {t('s7.cta')}
        </a>
      </div>
    </section>
  );
}